// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cookieNotice[data-v-aceee2da]{background-color:var(--footer-bg-color);border:0;bottom:0;color:var(--footer-link-color);display:block;height:auto;left:0;padding-bottom:5px;padding-top:5px;position:fixed;text-align:center;z-index:1001}#cookieNotice>*[data-v-aceee2da]{display:inline-block;margin:0 5px;vertical-align:middle}#cookieNotice .close-button[data-v-aceee2da]{font-size:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
